import { sameEquipmentKey, type LegacyEquipmentKey } from "./arsenal.js";
import type { ContractDefinition } from "./contracts.js";
import type { ContractDifficulty } from "./progression.js";
import { createContractRewardTerms, type ContractRewardTerms } from "./reward-rules.js";

export function createContractPurchaseRewards(
  terms: Pick<ContractDefinition, "id" | "unlock">,
  difficulty: ContractDifficulty,
): ContractRewardTerms {
  const rewards = createContractRewardTerms(terms.id, difficulty);
  if (terms.id === "intro") return rewards;
  const licenses: LegacyEquipmentKey[] = [];
  if (rewards.firstModule) licenses.push({ kind: "module", id: rewards.firstModule });
  if (terms.unlock !== "none") licenses.push({ kind: "passive", id: terms.unlock });
  for (const key of licenses)
    if (!rewards.blueprints.some(blueprint => sameEquipmentKey(blueprint.key, key)))
      rewards.blueprints.push({ key, successes: 1 });
  return { ...rewards, firstModule: null };
}
